export default __webpack_public_path__ + "static/media/banner12.e00280dd.png";